export const HOME_BANNER_SKELETON_ASPECT_CLASS_NAME = 'aspect-[335/84]'

export const HomeBannerSkeleton = ({ className }: { className?: string }) => {
  return (
    <div className={['rounded-lg overflow-hidden ml-0', className].filter(Boolean).join(' ')}>
      <div className={`w-full ${HOME_BANNER_SKELETON_ASPECT_CLASS_NAME} animate-pulse bg-gray-200`} />
    </div>
  )
}
